import { PublicApi } from '@izimi/api';
import { createPublicModule } from '@izimi/modules';
import { fetchService } from 'core/services/fetchService';

const publicModule = createPublicModule({ publicApi: new PublicApi(fetchService) });

export const usePortalConfiguration = publicModule.usePortalConfiguration;
